import { createProjectLogger, createModuleLogger } from '@metamask/utils';

export const projectLogger = createProjectLogger('eth-block-tracker');

export { createModuleLogger };
